import { EvaluationMediums } from '../constants/manual-evaluation';
import { IDigitalPropertyType } from '../interfaces/digital-property.interface';
import {
  $digitalPropertyType,
  DigitalPropertyTypeNames,
  MOBILE_DIGITAL_PROPERTY_TYPE_NAMES,
} from '../constants/digital-properties';

export class DigitalPropertyTypeUtility {
  public static isWebsite(type: IDigitalPropertyType): boolean {
    return type?.canRestrictDomain;
  }

  public static isMobile(type: IDigitalPropertyType): boolean {
    return MOBILE_DIGITAL_PROPERTY_TYPE_NAMES.includes(type?.[$digitalPropertyType.name]);
  }

  /** Android app / iOS app type: the only types a mobile manual evaluation can be created on. */
  public static isMobileApp(type: IDigitalPropertyType): boolean {
    return this.isAndroid(type) || this.isIos(type);
  }

  /** Mobile manual evaluation medium for an Android app / iOS app type; `null` for any other type. */
  public static getMobileEvaluationMedium(
    type: IDigitalPropertyType,
  ): EvaluationMediums.androidApp | EvaluationMediums.iOSApp | null {
    if (this.isAndroid(type)) {
      return EvaluationMediums.androidApp;
    }
    if (this.isIos(type)) {
      return EvaluationMediums.iOSApp;
    }
    return null;
  }

  public static isAndroid(type: IDigitalPropertyType): boolean {
    return type?.[$digitalPropertyType.name] === DigitalPropertyTypeNames.android;
  }

  public static isIos(type: IDigitalPropertyType): boolean {
    return type?.[$digitalPropertyType.name] === DigitalPropertyTypeNames.ios;
  }
}
